/* eslint-disable indent */
import styled from 'styled-components';
import { Text, Space, Button } from '@cashfree-intl/coherent';

const border = ({ errorBorder }) =>
  // eslint-disable-next-line prettier/prettier
  `border: 1px solid ${errorBorder ? `var(--DANGER)` : `var(--SECONDARY_LIGHTER)`
  } !important;`;

export const StyledBusinessTypeDropdown = styled.div`
  .ui.fluid.selection.dropdown {
    ${border};
    margin-bottom: 0.5rem !important;
  }
`;

// eslint-disable-next-line no-undef, prettier/prettier
export const StyledStatusText = styled(Text) <{ status: any }>`
  ${({ status }: any) => {
    const bgMap = {
      VERIFIED: {
        'background-color': '#D9F1E0',
      },
      DUE_CURRENTLY: {
        'background-color': '#F9ECDA',
      },
      IN_KYC_REVIEW: {
        'background-color': '#DFE0E3',
      },
      ACTION_REQUIRED: {
        'background-color': '#F7DFDF',
      },
      default: {
        'background-color': '#fffff',
      },
    };
    const styles = bgMap[status] || bgMap.default;
    return Object.keys(styles)
      .map(key => `${key}: ${styles[key]};`)
      .join('');
  }};
  padding: 0.125rem 0.375rem;
  border-radius: 0.125rem;
  min-width: fit-content;
`;

export const StyledOptionalFieldInfoText = styled(Text)`
  padding: 0.625rem;
  background-color: #faf7ff;
  border-radius: 0.5rem;
`;

export const StyledDropdown = styled.div`
  .divider {
    border: 0 !important;
    margin: 0 !important;
  }
`;

export const StyledAlertText = styled.div`
  margin-bottom: 1.75rem;
`;

export const StyledTextDivider = styled(Space)`
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--SECONDARY_LIGHT);
  &::before,
  &::after {
    flex: 1;
    content: '';
    padding-top: 1px;
    padding-bottom: 1px;
    background-color: var(--DISABLED);
    margin: 0.5rem;
  }
`;

export const StyledDocCategoryDivider = styled.div`
  padding-top: 1px;
  padding-bottom: 1px;
  background-color: var(--DISABLED);
`;

export const StyledCompleteActivationButton = styled(Button)`
  white-space: normal !important;
  word-wrap: break-word;
`;
